import React, { Fragment } from 'react';
import { Button, FormGroup, Label, Input, FormFeedback, Col } from 'reactstrap';
import { Sidebar } from "primereact/sidebar";
import { FormNotificationMicrosite } from './FormNotificationMicrosite';
import { DialogPreviewResultsMicrosite } from '../../components/dashboard/defaultMicrositio/DialogPreviewResultsMicrosite';

export const IndexNotificationsMicrosite = ({
  visibleRight,
  setVisibleRight,
  notifications,
  loading,
  markAsRead,
  //? REFRESH
  refreshing, 
  
  newNotifications, handleCloseNotifications,
  //? PREVIEW AND DONWLOAD
  previewWorkOrderPDF, printWorkOrder,
  modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview,
  loadingDownloadPdf

  
}) => {

  return (
    <>

    <Sidebar
      className="sidebar-notifications"
      visible={visibleRight}
      closeOnEscape={true}
      position="right"
      // onHide={handleCloseNotifications}
      onHide={() => {
          if (modalPreviewPDF) return;
          handleCloseNotifications();
      }}
      modal={true}
      showCloseIcon={false}
      style={{
        background: 'rgba(39, 127, 168, 0.3)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
        width: '34%'
      }}
      
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="text-lg font-semibold mb-0" style={{ color: '#000000' }}>
          <b className='b-notification'>Notificaciones</b>
        </h5>
      </div>
      <hr />

      <FormNotificationMicrosite
        notifications={notifications}
        loading={loading}
        markAsRead={markAsRead}
        refreshing={refreshing}
        newNotifications={newNotifications}
        handleCloseNotifications={handleCloseNotifications}
        FormNotificationMicrosite={FormNotificationMicrosite}
        IndexNotificationsMicrosite={IndexNotificationsMicrosite}
        printWorkOrder={printWorkOrder}
        previewWorkOrderPDF={previewWorkOrderPDF}
        loadingDownloadPdf={loadingDownloadPdf}
      />

    </Sidebar>

    
    <DialogPreviewResultsMicrosite
        {
        ...{

            modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview

        }
        }
    />
    </>
    

  )

}